
import usefulLinkActions from '../../../actions/usefulLinkActions';
import usefulLinkTableColumns, {
  usefulLinkTableLeftFixedColumns,
  usefulLinkTableDataSortingByColumns,
  usefulLinkTableCellComponent,
  usefulLinkSelectionOperations,
} from './usefulLinkTableColumns';
import generateEntityTable from '../../../hocs/generateEntityTable';
import { getAbility } from 'reducers/sessionReducer';
import { store } from 'store';

const UsefulLinksTable = generateEntityTable({
  entityPluralString: 'usefulLinks',
  entityActions: usefulLinkActions,
  editorRoutePath: '/useful-link-edition',
  leftFixedColumns: usefulLinkTableLeftFixedColumns,
  dataSortingByColumns: usefulLinkTableDataSortingByColumns,
  selectionOperations: usefulLinkSelectionOperations,
  columns: usefulLinkTableColumns,
  openLinkOperation: true,
  editOperation: getAbility(store.getState()).can('update', 'UsefulLink'),
  deleteOperation: getAbility(store.getState()).can('update', 'UsefulLink'),
  enableSelection: getAbility(store.getState()).can('update', 'UsefulLink'),
});

export default UsefulLinksTable;
